import { isNull } from './isNull';
export function firstDefined(options = [], fallback = null) {
  for (let i = 0; i < options.length; i += 1) {
    if (!isNull(options[i])) {
      return options[i];
    }
  }
  return fallback;
}
